import { useHints } from './client-hints.js'
import { useRequestInfo } from './request-info.js'

export function useTheme() {
	const requestInfo = useRequestInfo()
	const hints = useHints()
	return requestInfo?.userPrefs.theme ?? hints?.theme
}
